import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const Section = styled.section`
  display: grid;
  gap: ${({ theme }) => theme.spacing(2)};
  padding: 0;
  margin: 0;
`;

export const Title = styled.h3`
  ${({ theme }) => typographyToCss(theme.typography.subtitle2)};
  margin: 0;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const Description = styled.p`
  ${({ theme }) => typographyToCss(theme.typography.caption)};
  margin: 0;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const Table = styled.div`
  display: grid;
  gap: ${({ theme }) => theme.spacing(2)};
  overflow-x: auto;
`;

export const HeaderRow = styled.div`
  display: grid;
  grid-template-columns:
    minmax(0, 1.4fr) 1.6em minmax(0, 1.4fr) minmax(0, 1fr) minmax(0, 1fr)
    1.6em;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const Row = styled(HeaderRow)``;

export const ColumnLabel = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.caption)};
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const SwapIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const SelectButton = styled.button`
  ${({ theme }) => typographyToCss(theme.typography.buttonSmall)};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(1)};
  width: 100%;
  min-width: 0;

  margin: 0;
  padding: ${({ theme }) => `${theme.spacing(1)} ${theme.spacing(2)}`};

  border-radius: ${({ theme }) => theme.spacing(2)};
  border: 1px solid ${({ theme }) => theme.palette.divider};
  background: ${({ theme }) => theme.palette.background.default};
  cursor: pointer;
  color: ${({ theme }) => theme.palette.text.primary};

  &:disabled {
    cursor: default;
    opacity: 0.6;
  }
`;

export const SelectValue = styled.span`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  min-width: 0;
`;

export const SelectLabel = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Placeholder = styled.span`
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const ChevronContainer = styled.span`
  display: flex;
  transform: rotate(270deg);
`;

export const CalendarColor = styled.span<{ $color: string }>`
  display: block;
  height: 1em;
  width: 0.3rem;
  flex-shrink: 0;

  background: ${({ $color }) => $color};
  border-radius: ${({ theme }) => theme.spacing(2)};
`;

export const RemoveButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  margin: 0;
  padding: ${({ theme }) => theme.spacing(1)};

  border: none;
  background: none;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.text.secondary};

  &:hover {
    color: ${({ theme }) => theme.palette.error.main};
  }
`;

export const AddButton = styled.button`
  ${({ theme }) => typographyToCss(theme.typography.buttonSmall)};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  align-self: start;

  margin: 0;
  padding: ${({ theme }) => `${theme.spacing(1)} 0`};

  border: none;
  background: none;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.primary.main};

  &:disabled {
    cursor: default;
    opacity: 0.6;
  }
`;

export const AddIconContainer = styled.span`
  display: flex;
`;

export const Upsell = styled.p`
  ${({ theme }) => typographyToCss(theme.typography.caption)};
  margin: 0;
  color: ${({ theme }) => theme.palette.text.secondary};
`;
